export const C = {
  sage: "#9FAC9D",
  linen: "#DFD8C5",
  cream: "#ECE4D7",
  sand: "#DDC8B7",
  blush: "#CDACA1",
  slate: "#89999A",
  dark: "#2C2826",
  mid: "#4A433E",
  white: "#FAFAF8",
};

export const IMG_COLORS = [
  "#C8B8A0","#D4A5A5","#B8A8C0","#E8C8C0","#D0B8A8",
  "#C0A8A0","#D8C8A8","#E0B8C0","#C8A0A0","#D4B0B8",
  "#D0C0A8","#A8B8C0","#C8D0B8","#D8C8B0","#B8C8A8",
  "#D0B8C0","#C8C0B0","#D8D0C0","#C0D0C8","#D8C0B8",
];

export const IMG_LABELS = [
 "Proposal 1","Proposal 2","Engagement Room","Girlfriend Setup",
  "Personalised Gift","Birthday Neon","Pink Balloons","Valentine Balloons","Galentine's",
  "Birthday Cake","Beach Proposal","White Floral Arch","Girlfriend Decor","Picnic Setup",
  "Gift Box","Gold Balloon Letters","Silver Balloons","Colourful Party","Pink Birthday",
];

export const SERVICES = [
  { title: "Girlfriend & Boyfriend Proposals", tag: "Ask Them In Style", price: "From R1,800", desc: "Creative setups with candles, rose petals, balloons and sweet gifts.", imgIdx: 4 },
  { title: "Engagement Proposals", tag: "The Perfect Yes", price: "From R2,500", desc: "Breathtaking 'Marry Me' setups with rose petals, balloon arches and personalised touches.", imgIdx: 1 },
  { title: "Birthday Celebrations", tag: "Celebrate You", price: "From R650", desc: "Balloon garlands, personalised backdrops and full theme décor for milestone birthdays.", imgIdx: 6 },
  { title: "Valentine's Day", tag: "Love Is In The Air", price: "From R3,000", desc: "Heart balloons, rose arrangements and in-room surprise setups for the one you love.", imgIdx: 8 },
  { title: "Anniversaries", tag: "Romance Elevated", price: "From R2,200", desc: "Elegant anniversary setups with florals, champagne and personalised poems.", imgIdx: 3 },
  { title: "Custom Cakes & Desserts", tag: "Sweet Moments", price: "From R1,200", desc: "Custom-designed cakes for birthdays and engagements — made with love.", imgIdx: 10 },
  { title: "Balloon Installations", tag: "Art in the Air", price: "From R240", desc: "Elegant balloon garlands and arches in silver, gold, white, pink.", imgIdx: 17 },
  { title: "Arts, Cards & Scrapbooks", tag: "Handcrafted With Love", price: "From R65", desc: "Custom cards, love journals, scrapbooks and gift frames — all handcrafted.", imgIdx: 5 },
  { title: "Outdoor Picnics", tag: "Al Fresco Elegance", price: "From R2,000", desc: "Styled outdoor picnics with low tables, cushions, florals and custom signage.", imgIdx: 14 },
];

export const STEPS = [
  { num: "01", title: "Chat With Us", desc: "Tell us about your event — theme, date and budget. We'll listen and understand your vision." },
  { num: "02", title: "We Design Your Package", desc: "Our team crafts a tailored proposal with décor ideas and a clear pricing breakdown." },
  { num: "03", title: "Enjoy Your Celebration", desc: "We set up everything while you relax. Every detail handled so you can be fully present." },
];

export const NAV_ITEMS = ["Home","Services","Packages","Build Your Own","Gallery","How It Works","Testimonials","Contact"];

export const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
